import {createAction} from "typesafe-actions";
import {Archetype, Callback, FullCredential, User, UserCredits} from "../types/users";
import {Paginated, Stored} from "../utils/commons";

export const setUser = createAction("USER/set", (user: User) => ({user}))();
export const setLoading = createAction("USER/loading", (loading: boolean) => (loading))();

export const gotApiKeys = createAction("USER/got credentials", (credentials: Credential[]) => (credentials))();
export const createdApiKeys = createAction("USER/created credentials", (credential: FullCredential) => credential)();
export const setCreating = createAction("USER/set creating", (creating: boolean) => creating)();
export const cleanApiKey = createAction("USER/clean credential")();
export const gotUserCredits = createAction("USER/got credits", (credits?: UserCredits) => (credits))();

export const gotCallbacks = createAction("USER/got callbacks", (callbacks?: Paginated<Stored<Callback>>) => (callbacks))();
export const gotArchetypes = createAction("USER/got archetypes", (archetypes?: Paginated<Stored<Archetype>>) => (archetypes))();
